import React, { ReactElement } from "react";
import clsx from "clsx";
import { cloneDeep } from "lodash";

import { OnlineLink } from "components";

import ArrowIcon from "static/images/arrow-right-point.png";
import styles from "./breadcrumbs.module.scss";

type Props = {
	pages: Array<{
		title: string;
		link?: string | null;
		titleComponent?: JSX.Element;
		onClick?: Function | null;
	}>;
	component?: ReactElement;
};

export const Breadcrumbs = ({ pages = [], component }: Props) => {
	const pagesLocal = cloneDeep(pages);
	const lastPage = pagesLocal.pop();

	return (
		<div className="d-flex">
			{pagesLocal.map((page, key) => (
				<div key={page.title + key} className="d-flex flex-shrink-1">
					<OnlineLink
						className={styles.prevBreadcrumb}
						to={page.link}
						onClick={page.onClick}
					>
						<div className="d-flex">
							<span
								className={clsx(page?.titleComponent && "mr-2")}
							>
								{page?.title}
							</span>
							{page?.titleComponent}
						</div>
					</OnlineLink>
					<img src={ArrowIcon} className={styles.arrowImg} alt="" />
				</div>
			))}
			{lastPage && (
				<p className={clsx(styles.currentBreadcrumb, "mb-0")}>
					{lastPage.title}
				</p>
			)}
			{component && (
				<div className={clsx(styles.currentBreadcrumb, "mb-0 ml-1")}>
					{component}
				</div>
			)}
		</div>
	);
};
